<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>리스닝 학습 관리</h2>
    </div>

    <ul class="categories flexL box" v-if="categories.length > 0">
      <li
        :class="{ unselect: true, active: category === '' }"
        @click="handleCategory('')"
      >
        전체 ({{ categoryTotal }})
      </li>
      <li
        :class="{ unselect: true, active: cat.name === category }"
        @click="handleCategory(cat.name)"
        v-for="(cat, i) in categories"
        :key="i"
      >
        {{ getCategoryDisplayName(cat.name) }} ({{ cat.count }})
      </li>
    </ul>
    <div class="box one">
      <div class="flexB mb20">
        <div class="flex searchWrap">
          <input
            type="text"
            v-model="searchWord"
            placeholder="Search"
            @keyup.enter="search"
          />

          <button @click="search" class="searchIcon">
            <img src="@/assets/images/icon_svg/search.svg" alt="search" />
          </button>
          <button class="cancel line" @click="reset">Cancel</button>
        </div>

        <div class="flex">
          <div class="filebox">
            <label for="fileUpload" class="basic w100 unselect">대량등록</label>
            <input
              id="fileUpload"
              type="file"
              @change="handleFileUpload"
              accept=".xlsx, .xls"
            />
          </div>
          <a
            class="line2 sample-link"
            :href="listeningBulkSampleHref"
            download="listening-bulk-sample.xlsx"
            >샘플 양식 다운로드</a
          >
          <button
            class="line2 sample-link"
            type="button"
            @click="downloadListeningData"
          >
            데이터 다운로드
          </button>
          <router-link
            class="line2"
            :to="
              category
                ? { path: '/admin/listening/register', query: { category } }
                : '/admin/listening/register'
            "
            >리스닝 등록</router-link
          >
        </div>
      </div>
      <table>
        <colgroup>
          <col style="width: 5%" />
          <col style="width: 7%" />
          <col style="width: 14%" />
          <col style="width: 20%" />
          <col style="width: 19%" />
          <col style="width: 19%" />
          <col style="width: 16%" />
        </colgroup>
        <tr>
          <th>
            <el-checkbox
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <button
              @click="deleteListenings"
              class="delete"
              v-if="ids.length > 0"
            >
              삭제
            </button>
          </th>
          <th>번호</th>
          <th>카테고리</th>
          <th>한국어 문장</th>
          <th>영어 해설</th>
          <th>일본어 해설</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in listeningList" :key="i">
          <td>
            <el-checkbox
              v-model="ids"
              :label="data._id"
              class="no-label-checkbox"
              @change="handleIdsChange"
            ></el-checkbox>
          </td>
          <td>{{ total - ((currentPage - 1) * 20 + i) }}</td>
          <td>{{ data.category }}</td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              getSentenceText(data)
            }}</router-link>
          </td>
          <td>{{ getHintSentenceEn(data) }}</td>
          <td>{{ getHintSentenceJp(data) }}</td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <div class="pagination" v-if="listeningList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="20"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

import moment from "moment";
import {
  fetchListeningList,
  fetchListeningCategories,
  createListeningBulk,
  removeListeningAll,
} from "@/api/admin";
import { format } from "@/mixins/format";
import NoData from "@/components/contents/Nodata";
import category from "@/config/listeningCategory.json";
import { getListeningCategoryDisplayName } from "@/utils/listeningCategoryDisplay";

const LISTENING_BULK_HEADERS = [
  "카테고리",
  "한국어 문장",
  "영어 힌트",
  "일본어 힌트",
  "정답처리문장1",
  "정답처리문장2",
  "정답처리문장3",
];

export default {
  mixins: [format],
  components: { NoData },
  name: "listeningManage",
  data() {
    return {
      moment: moment,
      loading: false,
      inputMode: "",
      searchWord: "",
      listeningList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
      categories: [],
      category: "",
      categoryTotal: 0,
      isUpload: false,
      ids: [],
      checkAll: false,
    };
  },
  computed: {
    listeningBulkSampleHref() {
      const base = process.env.BASE_URL || "/";
      return `${base.replace(/\/?$/, "/")}listening-bulk-sample.xlsx`;
    },
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "5");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "listeningRegister" && from.query.page) {
        vm.currentPage = parseInt(from.query.page);
      } else if (to.query.page) {
        vm.currentPage = parseInt(to.query.page);
      } else {
        vm.currentPage = 1;
      }

      if (from.name === "listeningRegister" && from.query.category) {
        vm.category = from.query.category;
      } else if (to.query.category) {
        vm.category = to.query.category;
      } else {
        vm.category = "";
      }

      const currentQueryPage = to.query.page;
      const currentQueryCategory = to.query.category;
      const newPage = String(vm.currentPage);
      const newCategory = vm.category;

      const shouldReplace =
        currentQueryPage !== newPage ||
        (currentQueryCategory || "") !== newCategory;

      if (shouldReplace) {
        const query = { page: newPage };
        if (newCategory) query.category = newCategory;

        vm.$router.replace({
          name: "listeningManage",
          query,
        });
      }

      vm.getListeningList();
    });
  },
  mounted() {
    this.loading = true;
    this.getCategories();
  },
  methods: {
    getCategoryDisplayName(name) {
      return getListeningCategoryDisplayName(name);
    },
    normalizeAnswers(sentence, answers = []) {
      const normalizedSentence = (sentence || "").trim();
      const merged = [normalizedSentence, ...answers]
        .map((item) => (item || "").toString().trim())
        .filter(Boolean);

      return [...new Set(merged)];
    },
    getSentenceText(item = {}) {
      return item.sentence || "";
    },
    getHintSentenceEn(item = {}) {
      return item.hintSentenceEn || "";
    },
    getHintSentenceJp(item = {}) {
      return item.hintSentenceJp || "";
    },
    // formatAnswers(item = {}) {
    //   const sentence = this.getSentenceText(item);
    //   const savedAnswers = Array.isArray(item.answers) ? item.answers : [];

    //   return this.normalizeAnswers(sentence, savedAnswers).join(", ");
    // },
    parseBulkAnswers(row = [], sentence = "") {
      const extraCells = [row[4], row[5], row[6]];
      const parsedAnswers = extraCells
        .map((value) => (value || "").toString().trim())
        .filter(Boolean);

      return this.normalizeAnswers(sentence, parsedAnswers);
    },
    deleteListenings() {
      let result = confirm("삭제 하시겠습니까?");
      if (!result) {
        return;
      }
      let data = {
        ids: this.ids,
      };
      removeListeningAll(data).then((res) => {
        if (res.data.status == 200) {
          alert("삭제 되었습니다.");
          this.reset();
          this.checkAll = false;
          this.ids = [];
        }
      });
    },
    handleCheckAllChange(val) {
      this.ids = val ? this.listeningList.map((item) => item._id) : [];
    },
    handleIdsChange() {
      this.checkAll = this.ids.length == this.listeningList.length;
    },
    buildListeningExportRow(item = {}) {
      const sentence = (item.sentence || "").toString().trim();
      const savedAnswers = Array.isArray(item.answers) ? item.answers : [];
      const extraAnswers = this.normalizeAnswers(sentence, savedAnswers).filter(
        (answer) => answer !== sentence,
      );

      return [
        item.category ?? "",
        sentence,
        item.hintSentenceEn ?? "",
        item.hintSentenceJp ?? "",
        extraAnswers[0] ?? "",
        extraAnswers[1] ?? "",
        extraAnswers[2] ?? "",
      ];
    },
    async fetchAllListeningsForExport() {
      const baseParams = {
        searchWord: this.searchWord,
        category: this.category,
      };
      const countRes = await fetchListeningList({
        ...baseParams,
        page: 1,
        limit: 1,
      });

      if (countRes.data.status !== 200) {
        throw new Error(
          countRes.data.message || "리스닝 목록을 불러오지 못했습니다.",
        );
      }

      const total = Number(countRes.data.total || 0);
      if (total === 0) {
        return [];
      }

      const listRes = await fetchListeningList({
        ...baseParams,
        page: 1,
        limit: total,
      });

      if (listRes.data.status !== 200) {
        throw new Error(
          listRes.data.message || "리스닝 목록을 불러오지 못했습니다.",
        );
      }

      return listRes.data.data || [];
    },
    async downloadListeningData() {
      this.loading = true;
      try {
        const listenings = await this.fetchAllListeningsForExport();
        if (listenings.length === 0) {
          return alert("다운로드할 데이터가 없습니다.");
        }

        const rows = listenings.map((item) =>
          this.buildListeningExportRow(item),
        );
        const worksheet = XLSX.utils.aoa_to_sheet([
          LISTENING_BULK_HEADERS,
          ...rows,
        ]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "리스닝목록");

        const categoryLabel = this.category || "전체";
        const dateLabel = moment().format("YYYYMMDD_HHmmss");
        XLSX.writeFile(
          workbook,
          `listening-data_${categoryLabel}_${dateLabel}.xlsx`,
        );
      } catch (err) {
        alert(err.message || "데이터 다운로드에 실패했습니다.");
      } finally {
        this.loading = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.isUpload = true;

      const reader = new FileReader();
      reader.onload = (e) => {
        const excel = new Uint8Array(e.target.result);
        const workbook = XLSX.read(excel, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // 첫 행(헤더) 제외
        const dataRows = rows.slice(1);

        let listenings = dataRows
          .filter((row) => {
            const category = row[0]?.toString().trim();
            const sentence = row[1]?.toString().trim();
            const hintSentenceEn = row[2]?.toString().trim();
            const hintSentenceJp = row[3]?.toString().trim();

            return (
              Boolean(category) &&
              Boolean(sentence) &&
              Boolean(hintSentenceEn) &&
              Boolean(hintSentenceJp)
            );
          })
          .map((row) => {
            const sentence = (row[1] ?? "").toString().trim();
            const hintSentenceEn = (row[2] ?? "").toString().trim();
            const hintSentenceJp = (row[3] ?? "").toString().trim();
            const answers = this.parseBulkAnswers(row, sentence);

            return {
              category: (row[0] ?? "").toString().trim(),
              sentence,
              hintSentenceEn,
              hintSentenceJp,
              answers,
            };
          });

        console.log("listenings", listenings);
        let data = {
          listenings: listenings,
        };
        createListeningBulk(data).then((res) => {
          if (res.data.status == 200) {
            alert("리스닝 문장 등록이 완료 되었습니다.");
            this.isUpload = false;
            this.reset();
          } else {
            let message = res.data.message;
            alert(message);
            this.isUpload = false;
          }
        });
      };
      reader.readAsArrayBuffer(file);
    },
    getCategories() {
      fetchListeningCategories().then((res) => {
        if (res.data.status == 200) {
          this.categoryTotal = res.data.totalCount;
          const categoryCounts = res.data.data || [];

          this.categories = category.categories.map((name) => {
            const found = categoryCounts.find((item) => item._id === name);
            return {
              name,
              count: found ? found.count : 0,
            };
          });
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
    handleCategory(cat) {
      this.loading = true;
      this.currentPage = 1;
      this.category = cat;

      let query = {
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "listeningManage",
        query: query,
      });

      this.getListeningList();
    },
    customFormatter(date) {
      return moment(date).format("YYYY년 MM월 DD일");
    },
    handleMove(id) {
      let query = {
        id: id,
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "listeningRegister",
        query: query,
      });
    },

    reset() {
      // this.inputMode = "";
      this.searchWord = "";
      this.listeningList = [];
      this.total = 0;
      this.currentPage = 1;
      this.category = "";
      this.handleCurrentChange(1);
    },
    search() {
      if (this.searchWord == "") {
        return alert("검색어를 입력해 주세요.");
      }
      this.getListeningList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let query = {
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "listeningManage",
        query: query,
      });
      this.getListeningList();
    },
    getListeningList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        category: this.category,
      };
      fetchListeningList(params).then((res) => {
        console.log("fetchListeningList", res);
        if (res.data.status == 200) {
          this.listeningList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
          this.loading = false;
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
a.line2.sample-link,
button.line2.sample-link {
  width: auto;
  padding: 0 12px !important;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: 400;
}
::v-deep .no-label-checkbox span {
  vertical-align: middle;
  line-height: 40px;
}

::v-deep .no-label-checkbox .el-checkbox__label {
  display: none;
}
button.delete {
  width: unset;
  height: unset;
  background: unset;
  border: none;
  font-size: 12px;
  margin-bottom: 4px;
  color: #9aa7c1;
}
</style>
